import type {IServiceConnection} from "@chaosinsight/postoffice-portalclient"
import Publishers from "@/managers/organization/publishers"

export default class ServiceConnection {
	public id: string
	public publisherId: number
	public serviceId: string
	public mustRenew: boolean
	public createdOn: Date
	public modifiedOn: Date

	public get isFacebook(): boolean {
		return this.publisherId === Publishers.facebookId
	}

	public get isInstagram(): boolean {
		return this.publisherId === Publishers.instagramId
	}

	constructor(id: string, publisherId: number, serviceId: string, mustRenew: boolean, createdOn: Date, modifiedOn: Date) {
		this.id = id
		this.publisherId = publisherId
		this.serviceId = serviceId
		this.mustRenew = mustRenew
		this.createdOn = createdOn
		this.modifiedOn = modifiedOn
	}

	public static fromApi(data: IServiceConnection): ServiceConnection {
		return new ServiceConnection(
			data.Id,
			data.TypeId,
			data.ServiceId,
			data.MustRenew,
			new Date(data.CreatedOn),
			new Date(data.ModifiedOn))
	}
}
